export default __webpack_public_path__ + "static/media/mic_icon_blocked.63cfa047.svg";